import AuthorizationService from 'volta/services/authorization';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { inject as service } from '@ember/service';

export default class CanView extends Helper {
  @service authorization!: AuthorizationService;

  onPermissionsInit = observer('authorization.permissions', () => {
    this.recompute();
  });
  compute([entityType, details]: [string, string]) {
    return this.authorization.canView(entityType, details);
  }
}
